import React from "react";
import { API } from "@/lib/api";
import {
  Sparkles, BarChart3, LineChart, PieChart, Search, Globe, Mail, MessageSquare, Megaphone, Target, Rocket, Zap,
  ShoppingCart, CreditCard, Users, Calendar, FileText, Camera, Video, Palette, PenTool, Code, Database, Shield,
  Bell, Star, Heart, Map, Phone, Bot,
} from "lucide-react";

export const APP_ICONS = {
  sparkles: Sparkles, chart: BarChart3, trend: LineChart, pie: PieChart, search: Search, globe: Globe, mail: Mail,
  chat: MessageSquare, megaphone: Megaphone, target: Target, rocket: Rocket, zap: Zap, cart: ShoppingCart, card: CreditCard,
  users: Users, calendar: Calendar, file: FileText, camera: Camera, video: Video, palette: Palette, pen: PenTool,
  code: Code, database: Database, shield: Shield, bell: Bell, star: Star, heart: Heart, map: Map, phone: Phone, bot: Bot,
};

export const APP_COLORS = {
  violet: ["#EDE7FF", "#723FFF"], ink: ["#E9E9EE", "#06060C"], green: ["#E6F7EE", "#1f9d55"], amber: ["#FFF4E0", "#b06a00"],
  rose: ["#FFE8EE", "#e11d48"], blue: ["#E5EEFF", "#2563eb"], teal: ["#E0F5F2", "#0d9488"],
};

const SIZES = { sm: ["h-7 w-7 rounded-lg", "h-3.5 w-3.5"], md: ["h-10 w-10 rounded-xl", "h-5 w-5"], lg: ["h-12 w-12 rounded-xl", "h-5 w-5"] };

export const appIconUrl = (appId, v) => `${API}/public/app-icon/${appId}${v ? `?v=${v}` : ""}`;

export function AppIcon({ appId, icon, size = "md", preview, className = "", testId }) {
  const [box, glyph] = SIZES[size] || SIZES.md;
  const kind = preview ? "upload" : icon?.kind;
  if (kind === "upload") {
    return (
      <div data-testid={testId} className={`${box} bg-white border border-[#EEEFEF] overflow-hidden flex items-center justify-center shrink-0 ${className}`}>
        <img src={preview || appIconUrl(appId, icon?.v)} alt="" className="h-full w-full object-contain p-1" />
      </div>
    );
  }
  const Glyph = (kind === "preset" && APP_ICONS[icon?.name]) || Sparkles;
  const [bg, fg] = (kind === "preset" && APP_COLORS[icon?.color]) || APP_COLORS.violet;
  return (
    <div data-testid={testId} className={`${box} flex items-center justify-center shrink-0 ${className}`} style={{ background: bg, color: fg }}>
      <Glyph className={glyph} />
    </div>
  );
}
